import angular from 'angular';

import './delivery/controller';
import './header/controller';
import './list/controller';
import './product_summary/controller';
import './refund/controller';
import './refund_list/controller';
import './settlement_history_list/controller';
import './settlement_summary/controller';
import './summary/controller';
import './total/controller';
import './void_list/controller';
import './instore_card/controller';
import './cash_app_pay/controller';

angular.module("merchant.application.module.order", [
]).controller("merchant.application.module.order.controller", [
    "$scope",
    function($scope) {

        if (! $scope.model) {
            $scope.model = {};
        }

    }
]);
